import React from 'react';
import SessionCapturePanel from './SessionCapturePanel';
import { FacilitatorDock } from './FacilitatorDock';
import type { StreamWorkspacePanelProps } from './streamMappingWorkspaceTypes';

const StreamMappingChatPanel: React.FC<StreamWorkspacePanelProps> = ({ stream, session }) => (
  <FacilitatorDock label={`${stream.name} · Value stream mapping`}>
  <SessionCapturePanel
    session={session.chat}
    className="smw-chat"
    ariaLabel={`Capture chat for ${stream.name}`}
    inputLabel={`Message for ${stream.name}`}
    emptyText="No narration yet. Start with what triggers the stream."
  />
  </FacilitatorDock>
);

export default StreamMappingChatPanel;
